import CoreFilters from 'components/Filters/CoreFilters';
import CommercialFilter from 'components/Filters/CommercialFilter';
import AdvancedDistanceFilter from 'components/Filters/AdvancedDistanceFilter';
import ExternalFilter from 'components/Filters/ExternalFilter';
import FrontageFilter from 'components/Filters/FrontageFilter';
import InternalFilter from 'components/Filters/InternalFilter';
import RuralFilter from 'components/Filters/RuralFilter';
import ServiceFilter from 'components/Filters/ServiceFilter';
import StructureFilter from 'components/Filters/StructureFilter';
import PropertyValuesFilter from 'components/Filters/PropertyValuesFilter';
import {
    COMMERCIAL_RANGE_LABELS,
    DISTANCE_LABELS, EXTERNAL_CHECKBOX_FILTER_LABELS, EXTERNAL_RANGE_FILTER_LABELS,
    EXTERNAL_TEXTFIELD_FILTER_LABELS,
    EXTERNAL_TEXTFIELD_FILTER_LABELS_NZ, FRONTAGE_FILTER_LABELS, INTERNAL_CHECKBOX_FILTER_LABELS,
    INTERNAL_RANGE_FILTER_LABELS, RURAL_CHECKBOX_FILTER_LABELS, RURAL_RANGE_FILTER_LABELS, SERVICE_FILTER_LABELS
} from './filterOptions';
import { isNZLocale } from 'lib/PropertyUtils';
import PropertyValuesFilterNz from 'components/Filters/PropertyValuesFilterNz';

export const NAVIGATION_FILTERS_AU = [
    { label: 'Core Filters', value: 'core_filters', disabled: false, component: CoreFilters },
    { label: 'Commercial', value: 'commercial', disabled: false, advancedFilter: true, component: CommercialFilter },
    { label: 'Distances', value: 'distances', disabled: false, advancedFilter: true, component: AdvancedDistanceFilter },
    { label: 'External', value: 'external', disabled: false, advancedFilter: true, component: ExternalFilter },
    { label: 'Frontage', value: 'frontage', disabled: false, advancedFilter: true, component: FrontageFilter },
    { label: 'Internal', value: 'internal', disabled: false, advancedFilter: true, component: InternalFilter },
    { label: 'Property Values', value: 'property_values', disabled: false, advancedFilter: true, component: PropertyValuesFilter },
    { label: 'Rural', value: 'rural', disabled: false, advancedFilter: true, component: RuralFilter },
    { label: 'Service', value: 'service', disabled: false, advancedFilter: true, component: ServiceFilter },
    { label: 'Structure', value: 'structure', disabled: false, advancedFilter: true, component: StructureFilter },
];

export const NAVIGATION_FILTERS_NZ = [
    { label: 'Core Filters', value: 'core_filters', component: CoreFilters },
    { label: 'External', value: 'external', advancedFilter: true, component: ExternalFilter },
    { label: 'Property Values', value: 'property_values', advancedFilter: true, component: PropertyValuesFilterNz },
    { label: 'Commercial', value: 'commercial', disabled: true, },
    { label: 'Distances', value: 'distances', disabled: true, },
    { label: 'Frontage', value: 'frontage', disabled: true, },
    { label: 'Internal', value: 'internal', disabled: true, },
    { label: 'Rural', value: 'rural', disabled: true, },
    { label: 'Service', value: 'service', disabled: true, },
];

export const CORE_FILTERS = [
    'distance',
    'targetSuburbOnly',
    'excludeRecentlyAdvisedSales',
    'excludeRelatedParties',
    'isActiveForSaleCampaign',
    'isActiveForRentCampaign',
    'propertyType',
    'listingType',
    'beds',
    'baths',
    'cars',
    'price',
    'landArea',
    'floorArea',
    'yearBuilt',
    'propertySubType',
    'landUse',
    'devZone',
    'keywords',
    'date',
    'settlementDate',
    'firstListingDate',
    'salesClassification',
    'rentalLastCampaignStartDate',
];

export const COMMERCIAL_FILTERS = [
    'feeCode',
    ...Object.keys(COMMERCIAL_RANGE_LABELS),
];

export const DISTANCE_FILTERS = [
    ...Object.keys(DISTANCE_LABELS),
];

export const EXTERNAL_TEXTBOX_LABEL = isNZLocale() ? EXTERNAL_TEXTFIELD_FILTER_LABELS_NZ
    : EXTERNAL_TEXTFIELD_FILTER_LABELS;

export const EXTERNAL_FILTERS = [
    ...Object.keys(EXTERNAL_TEXTBOX_LABEL),
    ...Object.keys(EXTERNAL_CHECKBOX_FILTER_LABELS),
    ...Object.keys(EXTERNAL_RANGE_FILTER_LABELS),
];

export const FRONTAGE_FILTERS = [
    ...Object.keys(FRONTAGE_FILTER_LABELS),
];

export const INTERNAL_FILTERS = [
    ...Object.keys(INTERNAL_CHECKBOX_FILTER_LABELS),
    ...Object.keys(INTERNAL_RANGE_FILTER_LABELS),
    'heritageOtherClassification',
];

export const PROPERTY_VALUES_FILTERS = [
    'latestConsumerSaleEstimate',
    'latestConsumerSaleConfidence',
    'currentUnimprovedLandValue',
    'unimprovedCapitalValue',
    'unimprovedCapitalValueDate',
    'valuationCapitalValue',
    'valuationAssessmentDate',
    'valuationLandValue',
    'valuationImprovementsValue',
];

export const RURAL_FILTERS = [
    ...Object.keys(RURAL_CHECKBOX_FILTER_LABELS),
    ...Object.keys(RURAL_RANGE_FILTER_LABELS),
];

export const SERVICE_FILTERS = [
    ...Object.keys(SERVICE_FILTER_LABELS),
];

export const STRUCTURE_FILTERS = [
    'buildingArea',
    'equivalentBuildingArea',
    'floorLevelOfUnit',
    'floorLevelsInsideUnit',
    'flats',
    'totalFloorsInBuilding',
    'streetFrontage',
    'yearBuildingRefurbished',
    'yearEstablished',
    'freeStandingBuilding',
];
